import { render, staticRenderFns } from "./agent-chat-widget.vue?vue&type=template&id=50bcc4b0&scoped=true"
import script from "./agent-chat-widget.vue?vue&type=script&lang=js"
export * from "./agent-chat-widget.vue?vue&type=script&lang=js"
import style0 from "./agent-chat-widget.vue?vue&type=style&index=0&id=50bcc4b0&prod&scoped=true&lang=css"
import style1 from "./agent-chat-widget.vue?vue&type=style&index=1&id=50bcc4b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bcc4b0",
  null
  
)

export default component.exports